import { PlanContext } from '../models/annual-plan.model';

/** URL obfuscation only; this is not encryption or tamper protection. */
export function encodePlanContext(context: PlanContext): string {
  return btoa(JSON.stringify({
    siteId: context.siteId,
    bpgId: context.bpgId,
    fiscalYear: context.fiscalYear
  })).replace(/\+/g, '-').replace(/\//g, '_').split('=')[0];
}

/** Reject malformed links before requesting a plan. */
export function decodePlanContext(value: string | null): PlanContext | null {
  if (!value || !/^[A-Za-z0-9_-]+$/.test(value) || value.length % 4 === 1) {
    return null;
  }
  try {
    const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
    const context = JSON.parse(atob(base64 + '='.repeat((4 - base64.length % 4) % 4)));
    if (!context || ![context.siteId, context.bpgId, context.fiscalYear]
      .every(item => Number.isSafeInteger(item) && item > 0)) {
      return null;
    }
    return { siteId: context.siteId, bpgId: context.bpgId, fiscalYear: context.fiscalYear };
  } catch (error) {
    console.warn('Ignoring a malformed annual plan link.', error);
    return null;
  }
}